import React from 'react';
import Dropzone from 'react-dropzone';

import SVGIcon from 'src/components/svg';

import { lang } from 'src/helpers';
import AlertManager from 'src/components/alert/AlertManager';
import LANG_CONST from 'src/helpers/lang/const';
import { isAllowedFile, isValidFile } from 'src/helpers/fileCheck';

export class DropBox extends React.PureComponent {
  onUpload = async (files) => {
    // 1) extension allowlist (fast), 2) real content (magic bytes, SVG without script)
    const allowedFiles = files.filter(isAllowedFile);
    const contentOk = await Promise.all(allowedFiles.map(isValidFile));
    const filteredFiles = allowedFiles.filter((file, index) => contentOk[index]);

    if (filteredFiles.length !== files.length) {
      this.reject();
    }

    if (filteredFiles.length > 0) {
      this.props.onUpload(this.props.name, filteredFiles);
    }
  };

  reject = () => {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.validation.file_invalid,
      actionButton: {
        label: LANG_CONST.buttons.ok,
        action: (actions) => actions.hide()
      }
    });
  };

  render() {
    let {
      invalid,
      name,
      type = 'default',
      labelIcon = LANG_CONST.buttons.add_files,
      dropBoxStyles = {},
      accept,
      multiple,
      testId = 'dropbox',
      inputTestId = 'dropbox-input'
    } = this.props;
    return (
      <Dropzone
        onDropAccepted={this.onUpload}
        onDropRejected={this.reject}
        accept={accept}
        multiple={multiple}
      >
        {({ getRootProps, getInputProps }) => (
          <div
            {...getRootProps({
              className: 'mc-dropbox mc-dropbox-' + type,
              style: dropBoxStyles,
              'data-testid': testId
            })}
          >
            <input {...getInputProps({ 'data-testid': inputTestId })} />
            <SVGIcon iconname={'plus-icon'} />
            <div className={'mc-dropbox-text'}>{lang.t(labelIcon)}</div>
            {invalid && invalid[name] && (
              <div className='mc-form-invalid-text'>{invalid[name]}</div>
            )}
          </div>
        )}
      </Dropzone>
    );
  }
}
